import { ProfiauswahlModal } from "../Pdf/ProfiAuswahl";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { pdfSet } from "../Redux/pdfSlice";
import { IntToBetrag, IntToBetragText } from "../Helper/ZahlenFormat";
import { DelphiDatumShowText } from "../Helper/DateTimeHelper";
import {getSaldoSoll,getSaldoHaben} from "../Helper/PrKontoHelper";

export const KontenDatenJournalPdf = ({
  showProfiAuswahl,
  setShowProfiAuswahl,
  kontoData,
  dataSource,
  user,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDruckBtnClick = (art, profiName) => {
    //console.log("Profidruck Art",art);
    let summeSoll=0;
    let summeHaben=0;
    let defWidths = [25, 20, 20, 20, 20];
    let defAligns = ["left", "left", "left", "left", "left"];
    let defNachkommas = [0, 0, 0, 0, 0];
    const getDatenZeilen = () => {
      const getDatenZeilenSpalten0 = (item) => {
        const retArray = [];
        retArray.push(DelphiDatumShowText(item.datum));
        retArray.push(item.beleg);
        retArray.push(item.Butext);
        retArray.push(item.soll);
        retArray.push(item.haben);
        summeSoll+=item.soll;
        summeHaben+=item.haben;
        return retArray;
      };
      const getDatenZeilenSpalten1 = (item) => {
        const retArray = [];
        retArray.push(item.Name);
        retArray.push(item.Aufgabe);
        retArray.push(item.Teamleader);
        retArray.push(item.EMail);
        retArray.push(item.Info);
        return retArray;
      };
      const arrDaten = [];
      const addFilterdaten = (item, index) => {
        //console.log(item);
        switch (art) {
          /*
          case 1:
            arrDaten.push([item.Name]);
            // Hier die namen einfügen je Gruppe - Personen -> /personen/gruppennamenlist"
            break;
*/
          default:
            //console.log("DruckDatenZeile-item", item);
            arrDaten.push(getDatenZeilenSpalten0(item));
        }
      };
      switch (art) {
        /*
        case 1:
          defWidths = [15, 25, 25, 25];
          defAligns = ["left", "left", "left", "left"];
          arrDaten.push(["Gruppe", "Mitglied", "Handy", "EMail"]);
          break;
*/
        default:
          defWidths = [10, 10, 50, 15, 15];
          defAligns = ["left", "right", "left", "right", "right"];
          defNachkommas = [0, 0, 0, 2, 2];
          arrDaten.push(["Datum", "Beleg", "Buchungstext", "Soll", "Haben"]);
      }
      dataSource.map(
        (item, index) => item.Id !== 0 && addFilterdaten(item, index)
      );
      //console.log("arrDaten", arrDaten);
      return arrDaten;
    };
    const getHeadDatenArray = () => {
      switch (art) {
        /*
        case 1:
          return [
            ["Kontaktdaten der Personen"],
            ["vertraulich - für den internen Gebrauch bestimmt"],
            [""],
          ];
        */
        default:
          return [["Journalzeilen"], [""]];
      }
    };
    const pdfTabelle = () => {
      const arrayDaten = [];
      switch (art) {
        case 1:
          /*
          //const table1 = dataSource.map((item, index) => {
          //if (item.Id !== 0) {
          arrayDaten.push({
            texte: getDatenZeilen(),
            widths: defWidths,
            aligns: defAligns,
            fontSize: 11,
            fixedHead: true,
            fixedHeadLine: true,
            oddRowBackground: "#EEE",
            endeLinie: true,
          });
          //} else return null;
          //});
          //console.log(table1);
          //arrayDaten.push(table1);
          */
          break;
        default:
          arrayDaten.push({
            texte: getDatenZeilen(),
            widths: defWidths,
            aligns: defAligns,
            nachkommas: defNachkommas,
            fontSize: 11,
            fixedHead: true,
            fixedHeadLine: true,
            oddRowBackground: "#EEE",
            endeLinie: true,
          });
          arrayDaten.push({
            texte:[["","","Summen:",IntToBetragText(summeSoll),IntToBetragText(summeHaben)],
            ["","",((summeSoll-summeHaben)!==0)? "Saldo:":"",IntToBetragText(getSaldoSoll(summeSoll-summeHaben)),IntToBetragText(getSaldoHaben(summeSoll-summeHaben))]],
            widths: defWidths,
            aligns: defAligns,
            nachkommas: defNachkommas,
            fontSize: 11,            
          });
      }
      return arrayDaten;
    };

    const pdfDaten = {
      HomeLink: ["Konten", "/kontenrahmen"],
      PdfHead: {
        fixed: true,
        text: ["Kontoauszug", profiName, dayjs().format("DD.MM.YYYY")],
      },
      PdfHeadDatenArray: [{ texte: getHeadDatenArray(), fixed: true }],
      PdfDatenArray: pdfTabelle(),
      PdfFooterText: {
        textLink: "Powered by Aconsoft",
        textRechts: `${user.name}`,
      },
    };
    // console.log("XXX-pdfDaten", pdfDaten);
    dispatch(pdfSet(pdfDaten));
    navigate("/pdfViewhome");
  };

  return (
    <>
      <ProfiauswahlModal
        onConfirmOk={handleDruckBtnClick}
        onCancel={() => {
          setShowProfiAuswahl(false);
        }}
        visible={showProfiAuswahl}
        wahlCode="00002"
        //title="Wählen Sie eine Druckvorlage"
        textArray={["Kontoauszug"]}
      />
    </>
  );
};
